/**
 *
 * Asynchronously loads the component for SetNewPasswordPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
